import { render } from "./QC3AreaRetention.vue?vue&type=template&id=c35bdd4a"
import script from "./QC3AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC3AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC3AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c35bdd4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c35bdd4a', __exports__)) {
    console.log('reload')
    api.reload('c35bdd4a', __exports__)
  }
  
  module.hot.accept("./QC3AreaRetention.vue?vue&type=template&id=c35bdd4a", () => {
    console.log('re-render')
    api.rerender('c35bdd4a', render)
  })

}


export default __exports__